var $2b2734393847c884$exports = {};
$2b2734393847c884$exports = {
  "dismiss": `\u{95DC}\u{9589}`
};
export { $2b2734393847c884$exports as default };